<template>
  <div style="width: 100%; height: 100%" class="pt-5">
    <!-- Div contenente lo sfondo (fisso) di questa videata -->
    <div class="sfondo" style="position: fixed; left: 0px; top: 0px"></div>
    <v-row v-if="menu_visible">
      <v-col cols="0" md="4" class="py-0"></v-col>
      <v-col class="pr-md-1 px-10 py-0" cols="12" md="7">
        <!-- Menu di selezione -->
        <Menu
          style="display: inline-block; width: 100%"
          @click_causali_fermo="
            (causali_fermo_visible = true), (menu_visible = false)
          "
          @click_causali_scarto="
            (causali_scarto_visible = true), (menu_visible = false)
          "
          @click_fase_standard="
            (fase_standard_visible = true), (menu_visible = false)
          "
          @click_ciclo_standard="
            (ciclo_standard_visible = true), (menu_visible = false)
          "
          @click_ricerca_magazzino="
            (ricerca_magazzino = true), (menu_visible = false)
          "
          @click_avanzamento_conferma="
            (avanzamento_conferma_visible = true), (menu_visible = false)
          "
          @click_part_program="
            (part_program_visible = true), (menu_visible = false)
          "
          @click_macchina_protocol="
            (macchina_protocol_visible = true), (menu_visible = false)
          "
          @click_macchina_part_program="
            (macchina_part_program = true), (menu_visible = false)
          "
          @click_gestione_reparto="
            (gestione_reparto_visible = true), (menu_visible = false)
          "
          @click_config_reparto="
            (config_reparto_visible = true), (menu_visible = false)
          "
          @click_config_reparto2="
            (config_reparto2_visible = true), (menu_visible = false)
          "
          @click_calendario="
            (calendario_visibile = true), (menu_visible = false)
          "
          @click_report_commessa="
            (report_commessa_visible = true), (menu_visible = false)
          "
          @click_tipi_segnalazione="
            (tipi_segnalazione_visible = true), (menu_visible = false)
          "
          @click_configurazione_macchine="
            (configurazione_macchine_visible = true), (menu_visible = false)
          "
          @click_campi_macchine="
            (campi_macchine_visible = true), (menu_visible = false)
          "

          @click_movimenti="(movimenti_visible = true), (menu_visible = false)"
          @click_turni="(turni_visible = true), (menu_visible = false)"
          @go_to_dashboard="goToDashboard"
          v-if="menu_visible"
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="causali_fermo_visible">
      <v-col cols="10" class="py-0">
        <TabellaCausaliFermo
          @click_chiudi="(causali_fermo_visible = false), (menu_visible = true)"
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="causali_scarto_visible">
      <v-col cols="10" class="py-0">
        <TabellaCausaliScarto
          @click_chiudi="
            (causali_scarto_visible = false), (menu_visible = true)
          "
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="fase_standard_visible">
      <v-col cols="10" class="py-0">
        <TabellaFaseStandard
          @click_chiudi="(fase_standard_visible = false), (menu_visible = true)"
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="ciclo_standard_visible">
      <v-col cols="10" class="py-0">
        <TabellaCicloStandard
          @click_chiudi="
            (ciclo_standard_visible = false), (menu_visible = true)
          "
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="ricerca_magazzino">
      <v-col cols="10" class="py-0">
        <RicercaMovimenti
          @click_chiudi="(ricerca_magazzino = false), (menu_visible = true)"
        />
      </v-col>
    </v-row>

    <v-row justify="center" v-if="macchina_protocol_visible">
      <v-col cols="10" class="py-0">
        <AanagraficaQuickConnextBox
          @click_chiudi="
            (macchina_protocol_visible = false), (menu_visible = true)
          "
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="macchina_part_program">
      <v-col cols="10" class="py-0">
        <PartProgramIntializer
          @click_chiudi="(macchina_part_program = false), (menu_visible = true)"
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="gestione_reparto_visible">
      <v-col cols="10" class="py-0">
        <GestioneReparto
          @click_chiudi="
            (gestione_reparto_visible = false), (menu_visible = true)
          "
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="movimenti_visible">
      <v-col cols="10" class="py-0">
        <Movimenti
          @click_chiudi="(movimenti_visible = false), (menu_visible = true)"
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="turni_visible">
      <v-col cols="10" class="py-0">
        <ImpostazioniTurni
          @click_chiudi="(turni_visible = false), (menu_visible = true)"
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="config_reparto_visible">
      <v-col cols="10" class="py-0">
        <ConfigurazioneReparto
          @click_chiudi="
            (config_reparto_visible = false), (menu_visible = true)
          "
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="config_reparto2_visible" style="height: 100%">
      <v-col cols="10" class="py-0" style="height: 100%">
        <WindowFrame
          class="ma-0 pa-0"
          referrerpolicy="origin"
          ref="windowframe_magazzino"
          :component="'magazzino'"
          :input_args="input_args"
          :route="'/config/sedireparti'"
          style="height: 100%"
          @click_chiudi="
            config_reparto2_visible = false;
            menu_visible = true;
          "
          @loaded="sendParamsMag"
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="calendario_visibile">
      <v-col cols="11" class="py-0">
        <Calendario
          @click_chiudi="(calendario_visibile = false), (menu_visible = true)"
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="tipi_segnalazione_visible">
      <v-col cols="11" class="py-0">
        <TabellaTipiSegnalazione
          @click_chiudi="
            (tipi_segnalazione_visible = false), (menu_visible = true)
          "
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="report_commessa_visible">
      <v-col cols="11" class="py-0">
        <ReportCommessa
          @click_chiudi="
            (report_commessa_visible = false), (menu_visible = true)
          "
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="configurazione_macchine_visible">
      <v-col cols="11" class="py-0">
        <ConfigurazioneMacchine
          @click_chiudi="
            (configurazione_macchine_visible = false), (menu_visible = true)
          "
        />
      </v-col>
    </v-row>
    <v-row justify="center" v-if="campi_macchine_visible">
      <v-col cols="11" class="py-0">
        <CampiMacchine
          @click_chiudi="
            (campi_macchine_visible = false), (menu_visible = true)
          "
        />
      </v-col>
    </v-row>

    <v-overlay :value="caricamento_dati">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
import Menu from "@/components/PRODUCTION/Impostazioni/Menu.vue";
import ImpostazioniTurni from "@/components/PRODUCTION/Impostazioni/ImpostazioniTurni.vue";
import TabellaCausaliFermo from "@/components/PRODUCTION/Impostazioni/TabellaCausaliFermo.vue";
import TabellaCausaliScarto from "@/components/PRODUCTION/Impostazioni/TabellaCausaliScarto.vue";
import TabellaFaseStandard from "../../../components/PRODUCTION/Impostazioni/TabellaFaseStandardNew";
import TabellaCicloStandard from "../../../components/PRODUCTION/Impostazioni/TabellaCicloStandard.vue";
import TabellaTipiSegnalazione from "../../../components/PRODUCTION/Impostazioni/TabellaTipiSegnalazione.vue";
import RicercaMovimenti from "../../../components/PRODUCTION/Impostazioni/RicercaMovimenti.vue";
import AanagraficaQuickConnextBox from "@/components/PRODUCTION/Impostazioni/AanagraficaQuickConnextBox.vue";
import PartProgramIntializer from "@/components/PRODUCTION/Impostazioni/PartProgramIntializer.vue";
import ReportCommessa from "@/components/PRODUCTION/Impostazioni/ReportCommessa.vue";
import GestioneReparto from "@/components/PRODUCTION/Impostazioni/GestioneReparto.vue";
import ConfigurazioneReparto from "@/components/PRODUCTION/Impostazioni/ConfigurazioneReparto.vue";
import ConfigurazioneMacchine from "@/components/PRODUCTION/Impostazioni/ConfigurazioneMacchine.vue";
import CampiMacchine from "@/components/PRODUCTION/Impostazioni/CampiMacchine.vue";
import Calendario from "@/components/PRODUCTION/Impostazioni/Calendario/Calendario.vue";
import Movimenti from "@/components/PRODUCTION/Impostazioni/Movimenti.vue";

export default {
  name: "Avanzamento",
  components: {
    AanagraficaQuickConnextBox,
    GestioneReparto,
    Menu,
    PartProgramIntializer,
    RicercaMovimenti,
    TabellaCausaliFermo,
    TabellaCausaliScarto,
    TabellaCicloStandard,
    TabellaFaseStandard,
    TabellaTipiSegnalazione,
    Movimenti,
    ImpostazioniTurni,
    ConfigurazioneReparto,
    Calendario,
    ReportCommessa,
    WindowFrame,
    ConfigurazioneMacchine,
    CampiMacchine
  },
  props: {
    rotta_back: {
      type: String,
      default: "/home/production",
    },
    show_gestione_reparto: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      input_args: {
        cod_azienda: localStorage.getItem("cod_azienda"),
        id_azienda: localStorage.getItem("id_azienda"),
        show_toolbar: false,
      },
      // Modal
      avanzamento_conferma_visible: false,
      calendario_visibile: false,
      caricamento_dati: false,
      causali_fermo_visible: false,
      causali_scarto_visible: false,
      ciclo_standard_visible: false,
      config_reparto_visible: false,
      config_reparto2_visible: false,
      fase_standard_visible: false,
      gestione_reparto_visible: false,
      macchina_part_program: false,
      macchina_protocol_visible: false,
      menu_visible: true,
      movimenti_visible: false,
      part_program_visible: false,
      report_commessa_visible: false,
      ricerca_magazzino: false,
      tipi_segnalazione_visible: false,
      turni_visible: false,
      configurazione_macchine_visible: false,
      campi_macchine_visible: false,

      // Array
    };
  },
  methods: {
    sendParamsMag() {
      this.$refs.windowframe_magazzino.postEvent("setparams", {
        cod_azienda: localStorage.getItem("cod_azienda"),
        id_azienda: localStorage.getItem("id_azienda"),
        route: "/config/sedireparti",
      });
    },
    goToDashboard() {
      this.$router.push(this.rotta_back);
    },
  },
  mounted() {
    if (this.$route.params.comp == 4) {
      this.menu_visible = false;
      this.ciclo_standard_visible = true;
    }
  },
};
</script>
<style scoped>
.sfondo {
  width: 100vw !important;
  background-image: url("../../../assets/Ind.jpg");

  background-color: #cccccc; /* Used if the image is unavailable */
  height: 100vh !important; /* You must set a specified height */
  background-position: cover; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover;
  overflow: hidden !important; /* Resize the background image to cover the entire container */
}
</style>
